import Product from "../../../../../../@types/Product"
import SelectOption from "../../../../../../@types/SelectOption"
import LugNuts from "../../../Shared/LugNuts";

const ChromeLugnut = LugNuts[0];
const BlkLugnut = LugNuts[1];

const WheelSizeOptions: SelectOption[] = [
    { label: `12"`, value: 12, disabled: false, disabledMessage: '' },
    { label: `14"`, value: 14, disabled: false, disabledMessage: '' },
    { label: `15"`, value: 15, disabled: false, disabledMessage: '| only available with lift kit' },
]

const Wheels12In: Product[] = [
    {
        id: 1,
        refId: 12,
        name: '12" GTW Specter - Chrome x4',
        sku: '19-189',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/12-inch/gtw-12-specter-chrome-300x300.jpg`,
        price: 360,
        retailPrice: 100.00,
        linkedProducts: [ChromeLugnut],
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/05323655-bc21-4320-8841-53b99f15f500',
        visible: false
    },
    {
        id: 2,
        refId: 12,
        name: '12" GTW Spyder - Black with Machined Accents x4',
        sku: '19-218',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/12-inch/gtw-12-spyder-blackmachined-300x300.jpg`,
        price: 220.00,
        retailPrice: 0.00,
        linkedProducts: [ChromeLugnut],
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/de8b515e-4fd4-4c80-c204-0f3baeea5e00'
    },
    {
        id: 3,
        refId: 12,
        name: '12" GTW Spyder - Matte Black x4',
        sku: '19-246',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/12-inch/gtw-12-spyder-matteblack-300x300.jpg`,
        price: 240.00,
        retailPrice: 0.00,
        linkedProducts: [BlkLugnut],
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/b1033719-c246-4b1d-0005-34822ad24f00',
        visible: false
    },
    {
        id: 4,
        refId: 12,
        name: '12" GTW Spyder - Matte Gray x4',
        sku: '19-255',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/12-inch/gtw-12-spyder-mattegray-1-300x300.jpg`,
        price: 240.00,
        retailPrice: 0.00,
        linkedProducts: [BlkLugnut],
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/94fdf362-e201-4318-b866-80a330750b00'
    },
    {
        id: 5,
        refId: 12,
        name: '12" GTW Vortex 2 - Matte Black x4',
        sku: '19-232',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/12-inch/gtw-12-vortex-matteblack-300x300.jpg`,
        price: 240.00,
        retailPrice: 0.00,
        linkedProducts: [BlkLugnut],
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/84c31e6b-174e-494e-483e-e9dfdd9c1800'
    },
    {
        id: 6,
        refId: 12,
        name: '12" GTW Omega - Black with Machined Accents x4',
        sku: '19-260',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/12-inch/gtw-12-omega-black-300x300.jpg`,
        price: 240.00,
        retailPrice: 0.00,
        linkedProducts: [ChromeLugnut],
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/7ef7b28c-25be-4bec-0fe3-8554423de700'
    },
]

const Wheels12InLifted: Product[] = [
    {
        id: 1,
        refId: 12,
        name: '12" GTW Specter - Chrome x4',
        sku: '19-189',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/12-inch/gtw-12-specter-chrome-300x300.jpg`,
        price: 360,
        retailPrice: 100.00,
        linkedProducts: [ChromeLugnut],
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/63e5e105-c92d-4e2f-a8a2-88643fbb5a00',
        visible: false
    },
    {
        id: 2,
        refId: 12,
        name: '12" GTW Spyder - Black with Machined Accents x4',
        sku: '19-218',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/12-inch/gtw-12-spyder-blackmachined-300x300.jpg`,
        price: 220.00,
        retailPrice: 0.00,
        linkedProducts: [ChromeLugnut],
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/1ad89565-a445-4d41-1301-8a0fa0da6000'
    },
    {
        id: 3,
        refId: 12,
        name: '12" GTW Spyder - Matte Black x4',
        sku: '19-246',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/12-inch/gtw-12-spyder-matteblack-300x300.jpg`,
        price: 240.00,
        retailPrice: 0.00,
        linkedProducts: [BlkLugnut],
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/9e802976-80db-4910-b2a1-974c20ab6a00',
        visible: false
    },
    {
        id: 4,
        refId: 12,
        name: '12" GTW Spyder - Matte Gray x4',
        sku: '19-255',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/12-inch/gtw-12-spyder-mattegray-1-300x300.jpg`,
        price: 240.00,
        retailPrice: 0.00,
        linkedProducts: [BlkLugnut],
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/1f14f662-16af-4787-65de-d0f620747f00'
    },
    {
        id: 5,
        refId: 12,
        name: '12" GTW Vortex 2 - Matte Black x4',
        sku: '19-232',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/12-inch/gtw-12-vortex-matteblack-300x300.jpg`,
        price: 240.00,
        retailPrice: 0.00,
        linkedProducts: [BlkLugnut],
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/4431db44-ddc3-4c44-c707-f93111d37100'
    },
    {
        id: 6,
        refId: 12,
        name: '12" GTW Omega - Black with Machined Accents x4',
        sku: '19-260',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/12-inch/gtw-12-omega-black-300x300.jpg`,
        price: 240.00,
        retailPrice: 0.00,
        linkedProducts: [ChromeLugnut],
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/7101f4a1-991b-471e-751b-fc8fd62bac00'
    },
]

const Wheels14In: Product[] = [
    {
        id: 7,
        refId: 14,
        name: '14" GTW Specter - Chrome x4',
        sku: '19-190',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/14-inch/gtw-14-specter-chrome-1-300x300.jpg`,
        price: 440.00,
        retailPrice: 200.00,
        linkedProducts: [ChromeLugnut],
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/554c9ac4-6caf-4120-3875-330cf0747c00'
    },
    {
        id: 8,
        refId: 14,
        name: '14" GTW Spyder - Black with Machined Accents x4',
        sku: '19-221',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/14-inch/gtw-14-spyder-blackmachined-300x300.jpg`,
        price: 280.00,
        retailPrice: 150.00,
        linkedProducts: [ChromeLugnut],
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/c18d1238-e12d-4bd8-ddba-a63bca621e00',
        visible: false
    },
    {
        id: 9,
        refId: 14,
        name: '14" GTW Spyder - Matte Black x4',
        sku: '19-245',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/14-inch/gtw-14-spyder-matteblack-1-300x300.jpg`,
        price: 320.00,
        retailPrice: 150.00,
        linkedProducts: [BlkLugnut],
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/de922d5f-0533-49c1-5d6e-6abd83458100',
        visible: false
    },
    {
        id: 10,
        refId: 14,
        name: '14" GTW Spyder - Matte Gray x4',
        sku: '19-253',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/14-inch/gtw-14-spyder-matteblack-1-300x300.jpg`,
        price: 320.00,
        retailPrice: 150.00,
        linkedProducts: [BlkLugnut],
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/32e28f58-1d5c-4af5-a37e-45cef96a3400'
    },
    {
        id: 11,
        refId: 14,
        name: '14" GTW Bravo - Matte Bronze x4',
        sku: '19-224',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/14-inch/gtw-14-bravo-bronze-300x300.jpg`,
        price: 320.00,
        retailPrice: 150.00,
        linkedProducts: [BlkLugnut],
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/aca8fc9c-2633-45ec-f33c-d9db1a1b0b00'
    },
    {
        id: 12,
        refId: 14,
        name: '14" GTW Bravo - Matte Gray x4',
        sku: '19-225',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/14-inch/gtw-14-bravo-mattegray-1-300x300.jpg`,
        price: 320.00,
        retailPrice: 150.00,
        linkedProducts: [BlkLugnut],
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/224b1dea-4374-40ed-30c0-35cbca241500'
    },
    {
        id: 13,
        refId: 14,
        name: '14" GTW Bravo - Matte Black x4',
        sku: '19-251',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/14-inch/gtw-14-bravo-matteblack-1-300x300.jpg`,
        price: 320.00,
        retailPrice: 150.00,
        linkedProducts: [BlkLugnut],
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/f6f7be5a-6f48-4738-4b97-d25dfc59b900',
        visible: false
    },
    {
        id: 14,
        refId: 14,
        name: '14" GTW Raven - Matte Black with Ball Mill x4',
        sku: '19-226',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/14-inch/gtw-14-raven-blackmachined-300x300.jpg`,
        price: 320.00,
        retailPrice: 150.00,
        linkedProducts: [BlkLugnut],
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/c62af1c4-e08e-43e4-093a-336c49987e00',
        visible: false
    },
    {
        id: 15,
        refId: 14,
        name: '14" GTW Vortex 2 - Matte Black x4',
        sku: '19-229',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/14-inch/gtw-14-vortex-blackmatte-300x300.jpg`,
        price: 320.00,
        retailPrice: 150.00,
        linkedProducts: [BlkLugnut],
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/11d654fe-2bfd-4cc6-a39c-23c641fa9a00',
        visible: false
    },
    {
        id: 16,
        refId: 14,
        name: '14" GTW Vortex 2 - Matte Black with Machined Accent x4',
        sku: '19-230',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/14-inch/gtw-14-vortex-blackmachined-1-300x300.jpg`,
        price: 280.00,
        retailPrice: 150.00,
        linkedProducts: [ChromeLugnut],
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/11d654fe-2bfd-4cc6-a39c-23c641fa9a00'
    },
]

const Wheels14InLifted: Product[] = [
    {
        id: 7,
        refId: 14,
        name: '14" GTW Specter - Chrome x4',
        sku: '19-190',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/14-inch/gtw-14-specter-chrome-1-300x300.jpg`,
        price: 440.00,
        retailPrice: 200.00,
        linkedProducts: [ChromeLugnut],
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/6f7d1875-c26d-4400-f258-2f9ae7029b00'
    },
    {
        id: 8,
        refId: 14,
        name: '14" GTW Spyder - Black with Machined Accents x4',
        sku: '19-221',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/14-inch/gtw-14-spyder-blackmachined-300x300.jpg`,
        price: 280.00,
        retailPrice: 150.00,
        linkedProducts: [ChromeLugnut],
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/565f53b0-357e-4e6c-dd21-513ce67a3000',
        visible: false
    },
    {
        id: 9,
        refId: 14,
        name: '14" GTW Spyder - Matte Black x4',
        sku: '19-245',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/14-inch/gtw-14-spyder-matteblack-1-300x300.jpg`,
        price: 320.00,
        retailPrice: 150.00,
        linkedProducts: [BlkLugnut],
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/7e2fb341-32eb-480a-5248-dde512818200',
        visible: false
    },
    {
        id: 10,
        refId: 14,
        name: '14" GTW Spyder - Matte Gray x4',
        sku: '19-253',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/14-inch/gtw-14-spyder-matteblack-1-300x300.jpg`,
        price: 320.00,
        retailPrice: 150.00,
        linkedProducts: [BlkLugnut],
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/ab48bc78-aa37-4b1d-bbec-a3848d746200'
    },
    {
        id: 11,
        refId: 14,
        name: '14" GTW Bravo - Matte Bronze x4',
        sku: '19-224',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/14-inch/gtw-14-bravo-bronze-300x300.jpg`,
        price: 320.00,
        retailPrice: 150.00,
        linkedProducts: [BlkLugnut],
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/183e01e9-1bb8-42b6-3bea-e71007fcc400'
    },
    {
        id: 12,
        refId: 14,
        name: '14" GTW Bravo - Matte Gray x4',
        sku: '19-225',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/14-inch/gtw-14-bravo-mattegray-1-300x300.jpg`,
        price: 320.00,
        retailPrice: 150.00,
        linkedProducts: [BlkLugnut],
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/9ccf64c3-553a-4bb5-b2b0-71eca6e26f00'
    },
    {
        id: 13,
        refId: 14,
        name: '14" GTW Bravo - Matte Black x4',
        sku: '19-251',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/14-inch/gtw-14-bravo-matteblack-1-300x300.jpg`,
        price: 320.00,
        retailPrice: 150.00,
        linkedProducts: [BlkLugnut],
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/5979b802-bab0-48ac-28aa-bcf15ee97700',
        visible: false
    },
    {
        id: 14,
        refId: 14,
        name: '14" GTW Raven - Matte Black with Ball Mill x4',
        sku: '19-226',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/14-inch/gtw-14-raven-blackmachined-300x300.jpg`,
        price: 320.00,
        retailPrice: 150.00,
        linkedProducts: [BlkLugnut],
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/09050503-67c0-4988-d8bd-c1fb8b0a4a00',
        visible: false
    },
    {
        id: 15,
        refId: 14,
        name: '14" GTW Vortex 2 - Matte Black x4',
        sku: '19-229',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/14-inch/gtw-14-vortex-blackmatte-300x300.jpg`,
        price: 320.00,
        retailPrice: 150.00,
        linkedProducts: [BlkLugnut],
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/33330a5f-a838-477f-9748-2386a9c4f400',
        visible: false
    },
    {
        id: 16,
        refId: 14,
        name: '14" GTW Vortex 2 - Matte Black with Machined Accent x4',
        sku: '19-230',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/14-inch/gtw-14-vortex-blackmachined-1-300x300.jpg`,
        price: 280.00,
        retailPrice: 150.00,
        linkedProducts: [ChromeLugnut],
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/f8b51554-d800-4994-fe49-67530d7ea900'
    },
]

const Wheels15In: Product[] = [
    {
        id: 17,
        refId: 15,
        name: '15" MadJax® Flow Form Evolution - Matte Black x4',
        sku: '19-262',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/15-inch/madjax-15-flowform-matteblack-300x300.jpg`,
        price: 360.00,
        retailPrice: 300.00,
        linkedProducts: [BlkLugnut],
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/a18a3ff5-7cff-42a3-d76e-30cc38503b00'
    },
    {
        id: 18,
        refId: 15,
        name: '15" MadJax® Flow Form Evolution - Gunmetal x4',
        sku: '19-264',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/15-inch/madjax-15-flowform-gunmetal-300x300.jpg`,
        price: 360.00,
        retailPrice: 300.00,
        linkedProducts: [BlkLugnut],
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/a3f2941b-d01c-4062-fbfe-b7753d6aae00'
    },
    {
        id: 19,
        refId: 15,
        name: '15" GTW Bravo - Matte Black x4',
        sku: '19-300',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/15-inch/gtw-15-bravo-matteblack-1-300x300.jpg`,
        price: 360.00,
        retailPrice: 300.00,
        linkedProducts: [BlkLugnut],
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/9b3077c2-b734-491f-7dcd-3a2cfbe00d00'
    },
    {
        id: 20,
        refId: 15,
        name: '15" GTW Bravo - Matte Gray x4',
        sku: '19-302',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/15-inch/gtw-15-bravo-mattegray-1-300x300.jpg`,
        price: 360.00,
        retailPrice: 300.00,
        linkedProducts: [BlkLugnut],
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/afb9d4c0-2532-4dfc-8bff-aafa07c00800'
    },
    {
        id: 21,
        refId: 15,
        name: '15" GTW Spyder - Gloss Black with Machined Accents x4',
        sku: '19-306',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/15-inch/gtw-15-spyder-blackmachined-300x300.jpg`,
        price: 320.00,
        retailPrice: 300.00,
        linkedProducts: [ChromeLugnut],
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/0e1ec179-fa2b-490a-2fff-e0861c60aa00'
    },
    {
        id: 22,
        refId: 15,
        name: '15" GTW Spyder - Matte Black x4',
        sku: '19-307',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/15-inch/gtw-15-spyder-matteblack-1-300x300.jpg`,
        price: 320.00,
        retailPrice: 300.00,
        linkedProducts: [BlkLugnut],
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/bc131144-cc50-41a0-8097-692233395f00'
    },
]

export { 
    Wheels12In, 
    Wheels12InLifted,
    Wheels14In, 
    Wheels14InLifted,
    Wheels15In,
    WheelSizeOptions
}